import { render, staticRenderFns } from "./CredentialType.vue?vue&type=template&id=5b1458cc&scoped=true&"
import script from "./CredentialType.vue?vue&type=script&lang=js&"
export * from "./CredentialType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1458cc",
  null
  
)

export default component.exports